module.exports = __webpack_public_path__ + "media/2x/demographic-pie@2x-ff4e3c43.png";